import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';

import BreederQuoteCarousel from 'dpl/join_as_breeder/components/ContentQuoteCarousel';

function BreederQuoteCarouselContainer(props) {
  return (
    <div className="BreederQuoteCarouselContainer">
      <BreederQuoteCarousel {...props} />
    </div>
  );
}

export default compose(
  connect(({ server }) => ({
    title: server.pageSections.breeder_quotes.title,
    quotes: server.pageSections.breeder_quotes.page_items
  }))
)(BreederQuoteCarouselContainer);
